import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateCredentials, createSession } from '../config/authConfig';
import Diamond from '../components/Diamond';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Small delay for UX
    await new Promise(resolve => setTimeout(resolve, 300));

    if (validateCredentials(username, password)) {
      createSession(username);
      navigate('/dashboard');
    } else {
      setError('Wrong username or password.');
    }
    setIsLoading(false);
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-container">
        {/* Logo/Brand */}
        <div className="login-header">
          <h1 className="login-title">
            <Diamond color="#0057FF" size="md" />
            <span>Binary Game</span>
          </h1>
          <p className="login-subtitle">DASHBOARD LOGIN</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label htmlFor="username" className="login-label">USERNAME</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
              placeholder="Enter username"
              autoComplete="username"
              data-testid="login-username"
            />
          </div>

          <div className="login-field">
            <label htmlFor="password" className="login-label">PASSWORD</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              placeholder="Enter password"
              autoComplete="current-password"
              data-testid="login-password"
            />
          </div>

          {error && (
            <div className="login-error" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
            data-testid="login-submit"
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {/* Back to home link */}
        <a href="/" className="login-back-link">
          ← Back to Binary Game
        </a>
      </div>
    </div>
  );
};

export default Login;
